import React from 'react';
import Icon from '../../../components/AppIcon';

const InfoSection = ({ icon, title, children, className = "" }) => {
    return (
        <div className={`space-y-3 ${className}`}>
            <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary/10">
                    <Icon name={icon} size={18} className="text-primary" strokeWidth={2.5} />
                </div>
                <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
                    {title}
                </h3>
            </div>
            <div className="pl-10 md:pl-12">
                {children}
            </div>
        </div>
    );
};

export default InfoSection;